import { useMdBreakpoint } from '@/theme/hooks/useMdBreakpoint';
import { useSmBreakpoint } from '@/theme/hooks/useSmBreakpoint';
import { Container, Space } from '@mantine/core';
import { Step } from '../state/state.types';
import { Footnotes } from './Footnotes';

import { validateEnv } from '@/utils/validateEnv';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { fetchJSON } from '../fetchers/backend-fetchers';
import { CheckoutForm } from './CheckoutForm';

const stripeClientSecret = validateEnv().VITE_STRIPE_CLIENT_SECRET;
const stripePromise = loadStripe(stripeClientSecret);

export const PaymentFormWithTC = ({ footnotes }: { step: Step; footnotes?: string[] }) => {
  const isMdBreakpoint = useMdBreakpoint();
  const isSmBreakpoint = useSmBreakpoint();

  // const fields = useFields();
  // const isTCAccepted = fields?.agreement;

  const [clientSecret, setClientSecret] = useState('');

  const fetchClientSecret = () => {
    return fetchJSON<{ clientSecret: string }>('/checkout-session', {
      method: 'POST',
    }).then((data) => {
      setClientSecret(data.clientSecret);
    });
  };

  useEffect(() => {
    fetchClientSecret();
  }, []);

  // const {
  //   mutate: updateCase,
  //   isLoading,
  //   error,
  // } = useCaseUpdater({
  //   avoidUrlNavigation: true,
  //   onError: (error) => {
  //     emitHeapEvents({}, { ['payment-error']: error.message });
  //   },
  // });
  // const handleSubmit = async (token: TokenResult) => {
  //   if (!step?.id) {
  //     throw new Error('StepId should be provided');
  //   }

  //   if (token.status !== 'OK' || !token.token) {
  //     throw new Error('Card token should be provided');
  //   }

  //   if (!step.properties?.locationId || typeof step.properties?.locationId !== 'string') {
  //     throw new Error('Square location id should be provided');
  //   }

  //   if (!step.properties?.appId || typeof step.properties?.appId !== 'string') {
  //     throw new Error('Square app id should be provided');
  //   }

  //   const form = new FormData();
  //   form.append('stepId', step.id);
  //   form.append('sourceId', token.token);

  //   updateCase(form);
  // };

  return (
    <>
      <Container
        mt={24}
        w="100%"
        p={0}
      >
        {clientSecret && (
          <Elements
            stripe={stripePromise}
            options={{ clientSecret, locale: 'en' }}
          >
            <CheckoutForm clientSecret={clientSecret} />
          </Elements>
        )}
        {/* <PaymentForm
          // We ensured that appId and locationId are strings in the component above
          // TS can't infer that in JSX for now
          applicationId={step.properties?.appId as string}
          locationId={step.properties?.locationId as string}
          cardTokenizeResponseReceived={handleSubmit}
          formProps={{
            style: { display: 'flex', flexDirection: 'column' },
          }}
        >
          <CreditCard
            buttonProps={{
              isLoading: isLoading || !isTCAccepted,
              css: {
                color: theme.colors.primary[0],
                backgroundColor: theme.colors.secondary[0],
                borderRadius: '50px',
                fontFamily: theme.fontFamily,
                fontSize: theme.fontSizes.sm,
                fontWeight: 700,
                lineHeight: theme.lineHeight,
                padding: `0.375rem 2.5rem`,
                width: isMdBreakpoint || isSmBreakpoint ? 'auto' : '100%',
                alignSelf: isMdBreakpoint || isSmBreakpoint ? 'start' : 'center',
                border: `1px solid ${theme.colors.secondary[0]}`,
                boxShadow: `0px 2px 4px ${theme.colors.primary[0]}1A`,

                '&:disabled': {
                  color: theme.colors.neutral[1],
                  backgroundColor: theme.colors.neutral[4],
                  border: `1px solid ${theme.colors.neutral[4]}`,
                },
              },
            }}
          >
            Confirm payment
          </CreditCard>

          <Flex
            justify="start"
            mt={20}
          >
            <Text
              color="primary.1"
              size="sm"
              mr={6}
            >
              Transaction secured with
            </Text>
            <SquareLogo
              width={79}
              color={theme.colors.primary[1]}
            />
          </Flex>
        </PaymentForm> */}
        <Space h={isMdBreakpoint || isSmBreakpoint ? 20 : 8}></Space>
      </Container>
      {!!footnotes?.length && <Footnotes footnotes={footnotes} />}
    </>
  );
};
